<template>
    <div class="login">
        <div class="login-form">
            <div class="content">
                <label>
                    <span class="material-icons">account_circle</span>
                    <input type="text" placeholder="Username" v-model="username">
                </label>
                <label>
                    <span class="material-icons">lock</span>
                    <input type="password" placeholder="Password" v-model="password">
                </label>
                <button type="submit" @click="tryLogin">Login</button>
                <div class="btn partners" v-if="requestPartnersNeedsShow" @click="openSendMessagePopup">{{$t('SEND__REQUEST_PARTNERS')}}</div>

                <p v-show="incorrectLogin">Username Or Password Is Incorrect</p>
            </div>
        </div>

        <overlay :visible="alertPopup">
            <popup
                class="popup"
                @close="alertPopup = false"
                :title="'ATTENTION'"
                style="min-width: unset !important;"
            >
                <p>Bonjour a tous, <br/><br/>
                Suite a un problème de payement de la part de votre fournisseur, nous <br/>
                sommes dans l’obligation de fermer ses accès. <br/><br/>
                Cependant si vous souhaitez continuer à profiter du site, veuillez nous<br/> 
                contacter via whatsapp sur le numero suivant : <b>+491 633404666</b> <br/><br/>
                Merci</p>
            </popup>
        </overlay>
    </div>
</template>

<script>
import axios from '@/Helpers/AxiosInstance.js'

import Popup from '@/components/ReusableComponents/Popup/Popup.vue'
import Overlay from '@/components/ReusableComponents/Overlay/Overlay.vue'

export default {
    props: {
        logIn: Function,
    },
    components: {Popup, Overlay},
    data: function() {
        return {
            alertPopup: location.href.includes('knoozbet'),
            incorrectLogin: false,
            username: '',
            password: '',
            brandConfig: {"flashbet": 4,"danous": 39,"victoriabet": 62,"platingoal": 61},
        }
    },
    methods: {
        tryLogin() {
            axios
                .post('Profile/LogIn', {
                    userName: this.username,
                    password: this.password,
                    rememberMe: true,
                })
                .then(resp => {
                    if (resp.data.status == 1) this.logIn()
                    else this.incorrectLogin = true
                })
                .catch(() => (this.incorrectLogin = true))
        },
        openSendMessagePopup() {
            this.$emit('contactPopupVisible', true)
        }
    },
    computed: {
    requestPartnersNeedsShow() {
        const fullPath = location.origin
        const brandId = Object.keys(this.brandConfig).map(key => fullPath.includes(key) ? this.brandConfig[key] : false).find(el => !!el)    
        if(!!brandId) {
            this.$emit('change-brand', brandId)
            return true             
        }
        return false

    }  
      
    }
}
</script>

<style scoped lang="scss">
.login {
    background: url('~@/assets/images/login.jpg');
    background-size: cover;
    height: 100vh;
    width: 100vw;
    position: fixed;

    .login-form {
        overflow: hidden;
        width: 400 * $rem;
        margin: auto;
        margin-top: 200 * $rem;

        h3 {
            font-size: 24 * $rem;
            color: #fff;
            text-align: center;
            font-weight: 200;
        }

        p {
            font-size: 12 * $rem;
            font-weight: 200;
            text-align: center;
            color: #fff;
            padding: 10 * $rem 0;
        }

        .content {
            background-color: #fff;
            border-radius: 10 * $rem;
            padding: 60 * $rem;
            margin-top: 5 * $rem;

            label {
                border: 1 * $rem solid #c7c7c7;
                background-color: #fff;
                border-radius: 2 * $rem;
                width: 100%;
                height: 40 * $rem;
                display: block;
                margin-bottom: 20 * $rem;
                cursor: pointer;

                span {
                    display: inline-block;
                    float: left;
                    width: 40 * $rem;
                    height: 100%;
                    line-height: 40 * $rem;
                    text-align: center;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    font-size: 20 * $rem;
                    color: #b1b1b8;
                }

                input {
                    float: left;
                    width: calc(100% - 40 *#{$rem});
                    border: 0;
                    outline: 0;
                    height: 100%;
                }
            }

            button {
                background-color: #1874ef;
                color: #fff;
                margin-bottom: 15 * $rem;
                border: none;
                border-radius: 2 * $rem;
                width: 100%;
                height: 40 * $rem;
                box-sizing: border-box;
                transition: opacity 0.3s ease-out;
                cursor: pointer;
            }

            .partners.btn {
                min-width: 160px;
                margin: auto;
                display: flex;
                justify-content: center;
                align-content: center;
                background: linear-gradient(180deg, #37488A 0%, #56246D 100%);
            }

            p {
                text-align: center;
                margin-top: 10 * $rem;
                font-size: 13 * $rem;
                color: $red;
                font-weight: 500;
            }
        }
    }
}
</style>
